import { Config } from "@config";
import autobind from "autobind-decorator";
import React, { Suspense } from "react";
import type { ReactNode } from "react";
import { InView } from "react-intersection-observer";

interface Props {
	fallback?: ReactNode;
	prerender?: ReactNode;
	lazy?: boolean;
}

interface State {
	wasVisible: boolean;
}

export class LazyLoad extends React.Component<Props, State> {
	public constructor(props: Props) {
		super(props);

		this.state = { wasVisible: props.lazy !== true };
	}

	public render(): ReactNode {
		const { prerender = "", fallback = prerender, children } = this.props;
		const { wasVisible } = this.state;

		if (Config.isSsr()) {
			return prerender;
		}

		if (!wasVisible) {
			return (
				<InView as="div" onChange={this.handleVisibilityChange} threshold={0.1} triggerOnce>
					{fallback}
				</InView>
			);
		}

		return <Suspense fallback={fallback}>{children}</Suspense>;
	}

	@autobind
	private handleVisibilityChange(inView: boolean): void {
		if (inView) {
			this.setState({
				wasVisible: true,
			});
		}
	}
}
